<template>
  <div class="ocpc-record-box">
    <div class="total-box clearfix">
      <a-card
        v-for="(item, index) in staticData"
        :key="index"
      >
        <div class="ocpc-total-tit">
          <i
            class="ocpc-ico"
            :class="`ocpc-ico-${item.type}`"
          />
          <strong>{{ item.title }}</strong>
        </div>
        <div class="ocpc-total-list clearfix">
          <div class="ocpc-item">
            <h4>{{ $t('message["1828"]') }}</h4>
            <p>{{ item.todayData }}</p>
          </div>
          <div class="ocpc-item">
            <h4>{{ $t('message["1829"]') }}</h4>
            <p>{{ item.failNumber }}</p>
          </div>
          <div class="ocpc-item">
            <h4>{{ $t('message["1830"]') }}</h4>
            <p>{{ item.totalData }}</p>
          </div>
        </div>
      </a-card>
    </div>
    <filter-form @filterHandle="filterHandle" />
    <div class="ocpc-table-list">
      <a-table
        :columns="sendListColumns"
        :data-source="recordTableDatas"
        :pagination="false"
        :loading="!isRecordDataReady"
        :custom-header-row="expandAllHandler"
        :locale="{emptyText: setTxtTip }"
        :row-key="record => record.id"
        @change="handleChange"
      >
        <div
          slot="uptime"
          slot-scope="text"
        >
          {{ text * 1 > 0 ? $moment(text * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}
        </div>
        <div
          slot="type"
          slot-scope="text"
        >
          {{ channelType[text * 1 - 1] }}
        </div>
        <div
          slot="status"
          slot-scope="text"
          class="status-type"
          :class="[{'suc-status' : text * 1 === 1}, {'waiting-status' : text * 1 === 3}]"
        >
          {{ statusType[text * 1 - 1] }}
        </div>
        <em
          slot="filterIcon"
          class="th-filter-icon anticon anticon-filter ant-table-filter-icon ant-dropdown-trigger"
        >
          <i class="iconfont iconicon-test19" />
        </em>
        <div
          slot="filterDropdownChannel"
          slot-scope="{}"
          class="custom-filter-dropdown"
        >
          <div class="drop-down-box">
            <a
              href="javascript:;"
              @click="getList('type', 0)"
            >{{ $t('message["904"]') }}</a>
            <a
              href="javascript:;"
              @click="getList('type', 1)"
            >{{ $t('message["1827"]') }}</a>
            <a
              href="javascript:;"
              @click="getList('type', 2)"
            >Google</a>
            <a
              href="javascript:;"
              @click="getList('type', 3)"
            >Yandex</a>
          </div>
        </div>
        <em
          slot="filterIcon2"
          class="th-filter-icon anticon anticon-filter ant-table-filter-icon ant-dropdown-trigger"
        >
          <i class="iconfont iconicon-test19" />
        </em>
        <div
          slot="filterDropdown"
          slot-scope="{}"
          class="custom-filter-dropdown"
        >
          <div class="drop-down-box">
            <a
              href="javascript:;"
              @click="getList('status', 0)"
            >{{ $t('message["904"]') }}</a>
            <a
              href="javascript:;"
              @click="getList('status',1)"
            >{{ $t('message["1879"]') }}</a>
            <a
              href="javascript:;"
              @click="getList('status', 2)"
            >{{ $t('message["1880"]') }}</a>
            <a
              href="javascript:;"
              @click="getList('status', 3)"
            >{{ $t('message["1881"]') }}</a>
          </div>
        </div>
        <div
          slot="operate"
          slot-scope="text,record"
        >
          <a
            href="javascript:;"
            @click="viewRecordInfo(record)"
          >{{ $t('message["1316"]') }}</a>
        </div>
      </a-table>
      <pagination
        v-if="sendListColumns.length > 0 && recordTableDatas.length > 0"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
      <div
        v-if="recordTableDatas.length <= 0 && !isConfig"
        class="set-ocpc-link"
      >
        <a-button
          type="primary"
          @click="toSetOcpc"
        >
          {{ $t('message["1864"]') }}
        </a-button>
      </div>
      <record-info-modal
        ref="recordInfoModal"
        :item-data="itemData"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import FilterForm from './FilterForm'
import Pagination from '@/components/pc/Pagination'
import RecordInfoModal from './RecordInfoModal'
export default {
  components: {
    FilterForm,
    Pagination,
    RecordInfoModal
  },
  data () {
    return {
      filtersparams: {},
      itemData: {}
    }
  },
  computed: {
    ...mapState('config/ocpc', ['sendListColumns', 'pagination', 'recordTableDatas', 'statusType', 'channelType', 'isRecordDataReady', 'ocpcStatistiData', 'isConfig']),
    staticData () {
      const { ocpcStatistiData } = this
      let arr = []
      for (let key in ocpcStatistiData) {
        const val = ocpcStatistiData[key]
        const todayData = val[1] * 1
        const failNumber = val[2] * 1
        const totalData = val[3] * 1
        arr.push({ type: key, todayData, totalData, failNumber, title: this.channelType[key * 1 - 1] })
      }
      return arr
    },
    // 尚未设置ocpc推送，快去设置吧
    setTxtTip () {
      return !this.isConfig ? this.$t('message["1863"]') : this.$t('message["1553"]')
    }
  },
  async created () {
    await this.getOcpcstatistiData()
    await this.getOcpcRecordListDatas()
    if (this.isRecordDataReady) {
      this.pagination.currentPage = 1
      const { projectname = '', comname = '' } = this.$store.state.baseinfo
      document.title = 'oCPC' + `- ${projectname} - ${comname}`
    }
  },
  methods: {
    ...mapActions('config/ocpc', ['getOcpcstatistiData', 'getOcpcRecordListDatas']),
    async handleChange (pagination, filters, sorter) {
      let sort = 0
      if (sorter.order === 'ascend') {
        sort = 1
      } else if (sorter.order === 'descend') {
        sort = 0
      } else {
        sort = 0
      }
      this.filtersparams = { ...this.filtersparams, sort }
      this.$router.push({
        name: 'ocpc',
        query: { ...this.$route.query, sort }
      })
      await this.getOcpcRecordListDatas(this.$route.query)
      this.pagination.currentPage = 1
    },
    async handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize
        }
      })
      await this.getOcpcRecordListDatas({ ...this.$route.query })
    },
    async getList (type, val) {
      document.getElementById(type).querySelector(`.anticon-filter`).click()
      this.filtersparams = { ...this.filtersparams, [type]: val }
      this.$router.push({
        name: 'ocpc',
        query: { ...this.$route.query, [type]: val, page: 1 }
      })
      await this.getOcpcRecordListDatas({ ...this.filtersparams, [type]: val, page: 1 })
      this.pagination.currentPage = 1
      // this.pagination.pageSize = 10
      // this.reload()
    },
    // 渠道和状态筛选
    expandAllHandler (columns, record) {
      columns.forEach(item => {
        if (item.key === 'type' || item.key === 'status') {
          const obj = this.filtersparams[item.key]
          item.customHeaderCell = (record) => {
            return {
              attrs: {
                id: item.key,
                class: `ant-table-column-has-actions ant-table-column-has-filters ${obj ? 'filter-th-selected' : ''}`
              }
            }
          }
        }
      })
    },
    viewRecordInfo (record) {
      this.itemData = record
      this.$refs.recordInfoModal.changeLimitDialog(true)
    },
    toSetOcpc () {
      this.$router.push({ name: 'setList' })
    },
    async filterHandle (values) {
      this.filtersparams = values ? { ...values } : {}
      this.$router.push({
        name: 'ocpc',
        query: this.filtersparams
      })
      await this.getOcpcRecordListDatas(this.filtersparams)
      this.pagination.currentPage = 1
    }
  }
}
</script>
<style lang="scss" scoped>
  .ocpc-record-box::v-deep {
    .set-ocpc-link {
      text-align: center;
      margin-left: 16px;
    }
    .total-box {
      padding: 16px 0;
      margin-top: -8px;
    }
    .total-box > .ant-card {
      float: left;
      width: 330px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      border: 1px solid #EBEBEB;
      margin-right: 16px;
    }
    .total-box > .ant-card:last-child {
      margin-right: 0;
    }
    .ocpc-ico {
      width: 24px;
      height: 24px;
      background: url('../../../../assets/images/baidu.png') no-repeat 0 0;
      background-size: 24px 24px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;

    }
    .ocpc-ico-2 {
      background-image: url('../../../../assets/images/google.png')
    }
    .ocpc-ico-3 {
      background-image: url('../../../../assets/images/yandex.png')
    }
    .ocpc-total-tit {
      line-height: 24px;

      strong {
        font-weight: bold;
      }
    }
    .ocpc-item {
      float: left;
      width: 33.33%;
      padding-right: 10px;
      h4{
        color: #999;
        font-size: 12px;
        line-height: 16px;
        padding-bottom: 4px;
      }
      p{
        line-height: 20px;
        font-size: 16px;
        font-weight: bold;
      }
    }
    .ocpc-total-list {
      margin-left: 34px;
      padding-top: 16px;
    }
    .drop-down-box {
    width: auto;
    background: #fff;
    border-radius: 4px;
    line-height: 32px;
    position: relative;
    z-index: 6;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
    padding: 8px;
    a{
      display: block;
      color:#333;
      padding: 0 10px;
      text-align: left;
    }
    a:hover {
      background: #f4f7f9;
    }
  }
  .custom-filter-dropdown {
    padding-top: 13px;
  }
  .filter-th-selected {
    .anticon-filter {
      color: #5077aa;
    }
  }
  .status-type {
    color: #F57676;
  }
  .suc-status{
    color: #42C27E;
  }
  .waiting-status {
    color: #4CA0F2;
  }
  .ant-table-tbody > tr > td {
    word-break: break-all;
  }
  }
</style>
